import React, { useEffect, useState, useRef } from "react";
import favicon from "../assets/images/home/favicon.webp";
import aboutusimg from "../assets/images/home/section3img.webp";
import aboutuspot from "../assets/images/home/about-us-pot.webp";
import workicon1 from "../assets/images/home/workicon1.png";
import workicon2 from "../assets/images/home/workicon2.png";
import workicon3 from "../assets/images/home/workicon3.png";
import workicon4 from "../assets/images/home/workicon4.png";
import workborder from "../assets/images/home/workborder.png";
import benefit1img from "../assets/images/home/benefits1.webp";
import benefit2img from "../assets/images/home/benefits2.webp";
import benefit3img from "../assets/images/home/benefits3.webp";
import benefit4img from "../assets/images/home/benefits4.webp";
import benifitlogo from "../assets/images/home/benifit-img.png";
import getitonimg from "../assets/images/home/getitonimg.webp";
import getitonimg1 from "../assets/images/home/getitonimg1.webp";
import { faPlus, faMinus, faUser, faBars, faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Rating } from '@smastrom/react-rating'
import '@smastrom/react-rating/style.css';
import logo from '../assets/images/logo.png';
import fbicon from '../assets/images/home/fb.svg';
import twiitericon from '../assets/images/home/twitter.svg';
import instaicon from '../assets/images/home/insta.svg';
import { faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { Carousel } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import handwebp from '../assets/images/home/hand.webp';
import { Drawer, List, ListItem, ListItemText, Button } from '@mui/material';


const Home = () => {
  const faqdata = [
    {question: "What is Mansthal Farming Connection?", answer: "Mansthal Farming Connection is a digital networking platform created especially for farmers across India. Here, you can create your profile, share your farming experience, learn from others, and discuss modern techniques as well as traditional methods. Whether you are into crops, dairy, poultry, horticulture, or organic farming, Mansthal connects you with like-minded farmers so you can exchange ideas, solve problems faster, and grow together. It’s like a virtual farming community where knowledge travels from one field to another without boundaries."},
    {question: "Is Mansthal free to use?", answer: "Yes, Mansthal is completely free for all farmers. You don’t have to pay to sign up, connect, or share information. All features like joining groups, posting queries, viewing solutions, attending community discussions, and reading farming tips are open to every registered farmer. We believe that knowledge sharing should have no cost, so every farmer — big or small — can benefit from the collective wisdom of the community."},
    {question: "Can I get farming advice specific to my crop and region?", answer: "Absolutely! Mansthal allows you to join interest-based groups according to your crop type, farming method, and region. For example, if you grow wheat in Haryana, you can connect with other wheat farmers from similar climatic conditions and soil types. You can also ask location-specific questions about irrigation schedules, pest control, fertilizers, and government schemes. This ensures you get practical advice that works for your exact situation — not just general tips."}
  ]
  const [selectedindex, setselectedindex] = useState(0);
  const [activesection, setactivesection] = useState('Home');
  const [sticky, setSticky] = useState("");
  const [open, setOpen] = useState(false);
  
    const classes = `main-header ${sticky} mobhide`;

    const homeRef = useRef(null);
   const aboutRef = useRef(null);
   const featuresRef = useRef(null);
   const howitworksRef = useRef(null);
   const benifitsRef = useRef(null);
   const testimonialsRef = useRef(null);
   const faqRef = useRef(null);
   const contactRef = useRef(null);

   const toggleDrawer = (state) => {
    setOpen(state);
  };

   const scrollToHome = () => {
    if (homeRef.current) {
      const topOffset = homeRef.current.offsetTop; // adjust 80 for your header
      window.scrollTo({ top: topOffset, behavior: 'smooth' });
      setactivesection('Home');
      setOpen(false);
    }
  };

  const scrollToAbout = () => {
    const isHeaderFixed = window.scrollY >= 300; // Or your header fixed condition
    console.log("isHeaderFixed >>", isHeaderFixed);
    const offset = isHeaderFixed ? 60 : window.innerWidth <= 1024 ? 60 : 140;

    const y =
      aboutRef.current.getBoundingClientRect().top +
      window.pageYOffset -
      offset;
    window.scrollTo({ top: y, behavior: "smooth" });
    setactivesection("About");
    setOpen(false);
  };

  const scrollToFeature = () => {
    const isHeaderFixed = window.scrollY >= 300; // Or your header fixed condition
    console.log("scrollToFeature isHeaderFixed >>", isHeaderFixed);
    const offset = isHeaderFixed ? 60 : window.innerWidth <= 1024 ? 60 : 140;

    const y =
      featuresRef.current.getBoundingClientRect().top +
      window.pageYOffset -
      offset;
    window.scrollTo({ top: y, behavior: "smooth" });
    setactivesection("Feature");
    setOpen(false);
  };

  const scrollToHowItWorks = () => {
    const isHeaderFixed = window.scrollY >= 300; // Or your header fixed condition
    console.log("isHeaderFixed >>", isHeaderFixed);
    const offset = isHeaderFixed ? 60 : window.innerWidth <= 1024 ? 60 : 140;

    const y =
      howitworksRef.current.getBoundingClientRect().top +
      window.pageYOffset -
      offset;
    window.scrollTo({ top: y, behavior: "smooth" });
    setactivesection("HowItWorks");
    setOpen(false);
  };

  const scrollToBenefits = () => {
    const isHeaderFixed = window.scrollY >= 300; // Or your header fixed condition
    console.log("isHeaderFixed >>", isHeaderFixed);
    const offset = isHeaderFixed ? 60 : window.innerWidth <= 1024 ? 60 : 140;

    const y =
      benifitsRef.current.getBoundingClientRect().top +
      window.pageYOffset -
      offset;
    window.scrollTo({ top: y, behavior: "smooth" });
    setactivesection("Benefits");
    setOpen(false);
  };

  const scrollToTestimonials = () => {
    const isHeaderFixed = window.scrollY >= 300; // Or your header fixed condition
    console.log("isHeaderFixed >>", isHeaderFixed);
    const offset = isHeaderFixed ? 60 : window.innerWidth <= 1024 ? 60 : 140;

    const y =
      testimonialsRef.current.getBoundingClientRect().top +
      window.pageYOffset -
      offset;
    window.scrollTo({ top: y, behavior: "smooth" });
    setactivesection("Testimonials");
    setOpen(false);
  };

  const scrollToFaqs = () => {
    const isHeaderFixed = window.scrollY >= 300; // Or your header fixed condition
    console.log("isHeaderFixed >>", isHeaderFixed);
    const offset = isHeaderFixed ? 60 : window.innerWidth <= 1024 ? 60 : 140;

    const y =
      faqRef.current.getBoundingClientRect().top +
      window.pageYOffset -
      offset;
    window.scrollTo({ top: y, behavior: "smooth" });
    setactivesection("Faqs");
    setOpen(false);
  };
  
    useEffect(() => {
      // fetchcourses();
      const handleScroll = () => {
       if(window.innerWidth <= 1024) {
         return 
       }
       if (window.scrollY == 0 || window.scrollY < 100) {
        setactivesection("Home");
        return;
      }
       const scrollY = window.scrollY; // Add padding to detect a bit earlier

       

       console.log('scrollY >>', scrollY)
   
       const sections = [
         { id: "Home", ref: homeRef },
         { id: "About", ref: aboutRef },
         { id: "Feature", ref: featuresRef },
         { id: "HowItWorks", ref: howitworksRef },
         { id: "Benefits", ref: benifitsRef },
         { id: "Testimonials", ref: testimonialsRef },
         { id: "Faqs", ref: faqRef },
       ];
   
       for (let section of sections) {
         const offsetTop = section.ref?.current?.offsetTop;
         const offsetHeight = section.ref?.current?.offsetHeight;
   
         if (scrollY >= offsetTop - 100 && scrollY < offsetTop + offsetHeight - 100) {
           setactivesection(section.id);
           break;
         }
       }
  
       // sticky header
  
       const scrollTop = window.scrollY;
      const stickyClass = scrollTop >= 300 ? "is-sticky" : "";
      setSticky(stickyClass);
      console.log(stickyClass);
     };
  
      window.addEventListener("scroll", handleScroll);
      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
  
    }, []);
    const location = useLocation();
      useEffect(() => {
        if (location.hash) {
          const id = location.hash.replace("#", "");
          const el = document.getElementById(id);
          if (el) {
            const headerOffset = 140; // gap from top
            const elementPosition = el.getBoundingClientRect().top + window.scrollY;
            const offsetPosition = elementPosition - headerOffset;
    
            window.scrollTo({
              top: offsetPosition,
              behavior: "smooth",
            });
          }
        }
      }, [location]);
  return (
    <div className="main-body">
      {/* Header */}
      <section>
        <div className={classes} ref={homeRef} id="Home">
          <div className="container">
            <div className="header-row">
              <div className="logo-div">
                <img src={logo} className="logo-img" />
              </div>
              <div className="header-navbar">
                <nav className="navbar navbar-expand-lg  custom-nav ">
                  <ul class="navbar-nav">
                    <li
                      className={
                        activesection == "Home" ? "nav-item active" : "nav-item"
                      }
                    >
                      <p onClick={scrollToHome}>Home</p>
                    </li>
                    <li
                      className={
                        activesection == "About"
                          ? "nav-item active"
                          : "nav-item"
                      }
                    >
                      <p onClick={scrollToAbout}>About</p>
                    </li>
                    <li
                      className={
                        activesection == "Feature"
                          ? "nav-item active"
                          : "nav-item"
                      }
                    >
                      <p onClick={scrollToFeature}>Features</p>
                    </li>
                    <li
                      className={
                        activesection == "HowItWorks"
                          ? "nav-item active"
                          : "nav-item"
                      }
                    >
                      <p onClick={scrollToHowItWorks}>How it works</p>
                    </li>
                    <li
                      className={
                        activesection == "Benefits"
                          ? "nav-item active"
                          : "nav-item"
                      }
                    >
                      <p onClick={scrollToBenefits}>Benefits</p>
                    </li>
                    <li
                      className={
                        activesection == "Testimonials"
                          ? "nav-item active"
                          : "nav-item"
                      }
                    >
                      <p onClick={scrollToTestimonials}>Testimonials</p>
                    </li>
                    <li
                      className={
                        activesection == "Faqs" ? "nav-item active" : "nav-item"
                      }
                    >
                      <p onClick={scrollToFaqs}>FAQS</p>
                    </li>
                  </ul>
                </nav>
              </div>
              <div className="header-right-row">
                <Link
                  className="header-fb-icon"
                  to={"https://www.facebook.com/profile.php?id=61579143035601"}
                  target="_blank"
                >
                  <img src={fbicon} className="fbicon" />
                </Link>
                <Link
                  className="header-fb-icon"
                  to={"https://x.com/team_mansthal"}
                  target="_blank"
                >
                  <img src={twiitericon} className="fbicon" />
                </Link>
                <Link
                  className="header-fb-icon"
                  to={"https://www.instagram.com/team.mansthal/"}
                  target="_blank"
                >
                  <img src={instaicon} className="fbicon" />
                </Link>
                {/* <p className="header-border">|</p> */}
              </div>
            </div>
          </div>
        </div>
        {/* Mobile Menu */}
        <div className="deskhide">
          <div className="mobilemaindiv">
            <div
              className="mobilemenudiv"
              onClick={() => {
                setOpen(true);
              }}
            >
              <FontAwesomeIcon icon={faBars} className="menubaricon" />
            </div>
            <img src={logo} alt="Logo" className="website-logo-m" />
          </div>
          <div className="navbarheight" />
          <Drawer
            anchor="left"
            open={open}
            onClose={() => {
              toggleDrawer(false);
            }}
          >
            <List sx={{ width: 280 }}>
              <div className="mobilemenusidebarmaindiv">
                <div
                  className="mobilemenusidebar-closediv"
                  onClick={() => {
                    toggleDrawer(false);
                  }}
                >
                  <FontAwesomeIcon
                    icon={faXmark}
                    className="menubariconsidebar"
                  />
                </div>
                <div className="sidebarmain">
                  <nav className="navbar navbar-expand-lg  custom-nav ">
                    <ul class="navbar-nav">
                      <li
                        className={
                          activesection == "Home"
                            ? "nav-item active"
                            : "nav-item"
                        }
                      >
                        <p onClick={scrollToHome}>Home</p>
                      </li>
                      <li
                        className={
                          activesection == "About"
                            ? "nav-item active"
                            : "nav-item"
                        }
                      >
                        <p onClick={scrollToAbout}>About</p>
                      </li>
                      <li
                        className={
                          activesection == "Feature"
                            ? "nav-item active"
                            : "nav-item"
                        }
                      >
                        <p onClick={scrollToFeature}>Features</p>
                      </li>
                      <li
                        className={
                          activesection == "HowItWorks"
                            ? "nav-item active"
                            : "nav-item"
                        }
                      >
                        <p onClick={scrollToHowItWorks}>How it works</p>
                      </li>
                      <li
                        className={
                          activesection == "Benefits"
                            ? "nav-item active"
                            : "nav-item"
                        }
                      >
                        <p onClick={scrollToBenefits}>Benefits</p>
                      </li>
                      <li
                        className={
                          activesection == "Testimonials"
                            ? "nav-item active"
                            : "nav-item"
                        }
                      >
                        <p onClick={scrollToTestimonials}>Testimonials</p>
                      </li>
                      <li
                        className={
                          activesection == "Faqs"
                            ? "nav-item active"
                            : "nav-item"
                        }
                      >
                        <p onClick={scrollToFaqs}>FAQS</p>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </List>
          </Drawer>
        </div>
      </section>
      {/* Banner */}
      <section>
        <div className="main-banner-div">
          <div className="banner1">
            <div className="container">
              <div className="banner-content">
                <img src={favicon} className="banner-icon" />
                <p className="bannerhead-1">MANSTHAL</p>
                <p className="bannerhead-2">
                  CULTIVATING
                  <br />
                  CONNECTION.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Connect learn */}
      <section ref={aboutRef} id="About">
        <div className="section2bg">
          <div className="container">
            <div className="section2contentdiv">
              <p className="section2-head">Connect. Learn. Grow Together.</p>
              <img src={handwebp} className="handwebp deskhide" />
              <p className="section2-subhead">
                A social platform built exclusively for
                <br />
                India's farming community.
              </p>
              <p className="section2-desc">
                <b>Mansthal</b> is a mobile app that helps farmers connect,
                share
                <br />
                experiences, learn from each other, and grow their networks.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* About us  */}
      <section ref={featuresRef} id="Features">
        <div className="aboutusbg">
          <div className="aboutusimgdiv">
            <img src={aboutusimg} className="aboutusimg" />
          </div>
          <div className="container">
            <div className="about-us-left-div">
              <img src={aboutuspot} className="aboutuspot" />
              <p className="about-head">About the App</p>
              <p className="about-description">
                <span style={{ fontWeight: "500" }}>Mansthal</span> is a mobile
                app that helps farmers connect, share experiences,
                <br /> learn from each other, and grow their networks.
              </p>
              <p className="about-keyhead">KEY FEATURES</p>
              <p className="about-description">
                <span style={{ fontWeight: "500" }}>
                  Features Tailored for Farmers:
                </span>
              </p>
              <div className="features-maindiv">
                <div className="features-row">
                  <div className="featuredot"></div>
                  <p className="about-description">
                    Farmer Networking Connect with nearby and national farmers.
                  </p>
                </div>
                <div className="features-row">
                  <div className="featuredot"></div>
                  <p className="about-description">
                    Knowledge Sharing Share tips, techniques, and farming
                    success stories.
                  </p>
                </div>
                <div className="features-row">
                  <div className="featuredot"></div>
                  <p className="about-description">
                    Photo & Video Posts Post images of crops, problems, or
                    ideas.
                  </p>
                </div>
                <div className="features-row">
                  <div className="featuredot"></div>
                  <p className="about-description">
                    Mentorship Let young farmers learn from experienced ones.
                  </p>
                </div>
                <div className="features-row">
                  <div className="featuredot"></div>
                  <p className="about-description">
                    Location-based Groups Get local weather, mandi rates, and
                    crop alerts
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* How it Works */}
      <section ref={howitworksRef} id="Howitworks">
        <div className="howitworksbg">
          <div className="container">
            <div className="howitworkcontentdiv">
              <p className="about-head how-it-work-head">How it works?</p>
              <p className="about-keyhead how-it-work-subhead">
                Getting Started is Easy
              </p>
              <div className="work-circlerow">
                <div className="workbg1">
                  <img src={workicon1} className="workicon1" />
                  <p className="workbg-text">
                    Download
                    <br />
                    the App
                  </p>
                </div>
                <div className="workborderdiv">
                  <img src={workborder} className="workborderimg" />
                </div>
                <div
                  className="workbg1"
                  style={{ backgroundColor: "rgba(255, 189, 19, 1)" }}
                >
                  <img src={workicon2} className="workicon1" />
                  <p className="workbg-text">
                    Create Your
                    <br />
                    Profile
                  </p>
                </div>
                <div className="workborderdiv">
                  <img src={workborder} className="workborderimg" />
                </div>
                <div
                  className="workbg1"
                  style={{ backgroundColor: "rgba(234, 104, 46, 1)" }}
                >
                  <img src={workicon3} className="workicon1" />
                  <p className="workbg-text">
                    Start Sharing &<br />
                    Learning
                  </p>
                </div>
                <div className="workborderdiv">
                  <img src={workborder} className="workborderimg" />
                </div>
                <div
                  className="workbg1"
                  style={{ backgroundColor: "rgba(180, 45, 48, 1)" }}
                >
                  <img src={workicon4} className="workicon1" />
                  <p className="workbg-text">
                    Grow Your
                    <br />
                    Farming Network
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Benefits for Farmers */}
      <section ref={benifitsRef} id="Benefits">
        <div className="farmerbenifitbg">
          <div className="benifitlogodiv">
            <img src={benifitlogo} />
          </div>
          <div className="container">
            <div className="howitworkcontentdiv farmerbenifitcontentdiv">
              <p className="about-head farmer-benefit-head">
                Benefits for Farmers
              </p>
              <p className="farmer-benefit-subhead">
                Why Farmers Love Mansthal ?
              </p>
              <div className="benefitsrow">
                <div className="benefitsrowdiv1">
                  <div className="benefitnumberdiv">
                    <p>1</p>
                  </div>
                  <img src={benefit1img} className="benefit1img" />
                  <div className="benefitsrowcontentdiv">
                    <p className="benefitsrowcontent">
                      Stay updated with
                      <br />
                      farming trends and
                      <br />
                      government schemes.
                    </p>
                  </div>
                </div>
                <div className="benefitsrowdiv1">
                  <div className="benefitnumberdiv">
                    <p>2</p>
                  </div>
                  <img src={benefit2img} className="benefit1img" />
                  <div className="benefitsrowcontentdiv">
                    <p className="benefitsrowcontent">
                      Solve crop issues faster
                      <br />
                      with peer support.
                    </p>
                  </div>
                </div>
                <div className="benefitsrowdiv1">
                  <div className="benefitnumberdiv">
                    <p>3</p>
                  </div>
                  <img src={benefit3img} className="benefit1img" />
                  <div className="benefitsrowcontentdiv">
                    <p className="benefitsrowcontent">
                      Get inspiration from other
                      <br />
                      farmers stories.
                    </p>
                  </div>
                </div>
                <div className="benefitsrowdiv1">
                  <div className="benefitnumberdiv">
                    <p>4</p>
                  </div>
                  <img src={benefit4img} className="benefit1img" />
                  <div className="benefitsrowcontentdiv">
                    <p className="benefitsrowcontent">
                      Build a strong farming
                      <br />
                      community online.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Testimonials */}
      <section ref={testimonialsRef} id="Testimonials">
        <div className="testimonilbg">
          <div className="container">
            <div className="howitworkcontentdiv testimonial-content-div">
              <p className="about-head farmer-benefit-head">Testimonials</p>
              <p className="farmer-benefit-subhead testimonial-subhead">
                Hear From Our Farmers:
              </p>
              <Carousel
                interval={5000}
                controls={false}
                indicators={true}
                className="mobhide"
              >
                <Carousel.Item class="carousel-item active">
                  <div className="testimonalreviewrow">
                    <div className="testimonalreviewdiv">
                      <Rating style={{ maxWidth: 120 }} value={4} readOnly />
                      <p className="reviewtext">
                        Through Mansthal, I connected with farmers in my area
                        who guided me on modern irrigation techniques. I
                        increased my yield by almost 20% in just one season.
                        This platform truly bridges the gap between knowledge
                        and practice.
                      </p>
                      <div className="ratingpersonrow">
                        <div className="userbg">
                          <FontAwesomeIcon
                            icon={faUser}
                            className="fausericon"
                          />
                        </div>
                        <div className="ratingnamediv">
                          <p className="ratingname">Rajesh Kumar</p>
                          <p className="ratingaddress">Wheat Farmer, Haryana</p>
                        </div>
                      </div>
                    </div>
                    <div className="testimonalreviewdiv">
                      <Rating style={{ maxWidth: 120 }} value={5} readOnly />
                      <p className="reviewtext">
                        Earlier, I had no way to share my organic farming
                        methods with others. On Mansthal, I not only learned
                        from experienced farmers but also found buyers for my
                        produce. It’s like a digital village for farmers.
                      </p>
                      <div className="ratingpersonrow">
                        <div className="userbg">
                          <FontAwesomeIcon
                            icon={faUser}
                            className="fausericon"
                          />
                        </div>
                        <div className="ratingnamediv">
                          <p className="ratingname">Meena Devi</p>
                          <p className="ratingaddress">
                            Organic Farmer, Rajasthan
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </Carousel.Item>
                <Carousel.Item class="carousel-item">
                  <div className="testimonalreviewrow">
                    <div className="testimonalreviewdiv">
                      <Rating style={{ maxWidth: 120 }} value={5} readOnly />
                      <p className="reviewtext">
                        The discussions here saved me during a pest outbreak.
                        Fellow farmers suggested an eco-friendly solution that
                        worked perfectly. Mansthal has become my go-to place for
                        farming advice.
                      </p>
                      <div className="ratingpersonrow">
                        <div className="userbg">
                          <FontAwesomeIcon
                            icon={faUser}
                            className="fausericon"
                          />
                        </div>
                        <div className="ratingnamediv">
                          <p className="ratingname">Prakash Patil</p>
                          <p className="ratingaddress">
                            Sugarcane Farmer, Maharashtra
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="testimonalreviewdiv">
                      <Rating style={{ maxWidth: 120 }} value={4} readOnly />
                      <p className="reviewtext">
                        I met farmers from across states and learned how they
                        manage both crops and dairy together. Now, I’ve started
                        following mixed farming practices and my income has
                        grown steadily.
                      </p>
                      <div className="ratingpersonrow">
                        <div className="userbg">
                          <FontAwesomeIcon
                            icon={faUser}
                            className="fausericon"
                          />
                        </div>
                        <div className="ratingnamediv">
                          <p className="ratingname">Harjit Singh</p>
                          <p className="ratingaddress">
                            Dairy & Crop Farmer, Punjab
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </Carousel.Item>
              </Carousel>
              {/* For mobile */}
              <Carousel
                interval={5000}
                controls={false}
                indicators={true}
                className="deskhide"
              >
                <Carousel.Item class="carousel-item active">
                  <div className="testimonalreviewdiv">
                    <Rating style={{ maxWidth: 120 }} value={4} readOnly />
                    <p className="reviewtext">
                      Through Mansthal, I connected with farmers in my area who
                      guided me on modern irrigation techniques. I increased my
                      yield by almost 20% in just one season. This platform
                      truly bridges the gap between knowledge and practice.
                    </p>
                    <div className="ratingpersonrow">
                      <div className="userbg">
                        <FontAwesomeIcon icon={faUser} className="fausericon" />
                      </div>
                      <div className="ratingnamediv">
                        <p className="ratingname">Rajesh Kumar</p>
                        <p className="ratingaddress">Wheat Farmer, Haryana</p>
                      </div>
                    </div>
                  </div>
                </Carousel.Item>
                <Carousel.Item class="carousel-item">
                  <div className="testimonalreviewdiv">
                    <Rating style={{ maxWidth: 120 }} value={5} readOnly />
                    <p className="reviewtext">
                      Earlier, I had no way to share my organic farming methods
                      with others. On Mansthal, I not only learned from
                      experienced farmers but also found buyers for my produce.
                      It’s like a digital village for farmers.
                    </p>
                    <div className="ratingpersonrow">
                      <div className="userbg">
                        <FontAwesomeIcon icon={faUser} className="fausericon" />
                      </div>
                      <div className="ratingnamediv">
                        <p className="ratingname">Meena Devi</p>
                        <p className="ratingaddress">
                          Organic Farmer, Rajasthan
                        </p>
                      </div>
                    </div>
                  </div>
                </Carousel.Item>
                <Carousel.Item class="carousel-item">
                  <div className="testimonalreviewdiv">
                    <Rating style={{ maxWidth: 120 }} value={5} readOnly />
                    <p className="reviewtext">
                      The discussions here saved me during a pest outbreak.
                      Fellow farmers suggested an eco-friendly solution that
                      worked perfectly. Mansthal has become my go-to place for
                      farming advice.
                    </p>
                    <div className="ratingpersonrow">
                      <div className="userbg">
                        <FontAwesomeIcon icon={faUser} className="fausericon" />
                      </div>
                      <div className="ratingnamediv">
                        <p className="ratingname">Prakash Patil</p>
                        <p className="ratingaddress">
                          Sugarcane Farmer, Maharashtra
                        </p>
                      </div>
                    </div>
                  </div>
                </Carousel.Item>
                <Carousel.Item class="carousel-item">
                  <div className="testimonalreviewdiv">
                    <Rating style={{ maxWidth: 120 }} value={4} readOnly />
                    <p className="reviewtext">
                      I met farmers from across states and learned how they
                      manage both crops and dairy together. Now, I’ve started
                      following mixed farming practices and my income has grown
                      steadily.
                    </p>
                    <div className="ratingpersonrow">
                      <div className="userbg">
                        <FontAwesomeIcon icon={faUser} className="fausericon" />
                      </div>
                      <div className="ratingnamediv">
                        <p className="ratingname">Harjit Singh</p>
                        <p className="ratingaddress">
                          Dairy & Crop Farmer, Punjab
                        </p>
                      </div>
                    </div>
                  </div>
                </Carousel.Item>
              </Carousel>
            </div>
          </div>
        </div>
      </section>
      {/* Get it on div */}
      <section>
        <div className="getitonbg">
          <div className="container">
            <div className="getitonrow">
              <img src={getitonimg} className="getitonimg" />
              <div className="getitonrightdiv">
                <p className="about-head getiton-head">
                  Ready to Join the <br />
                  Digital Farming Movement?
                </p>
                <p className="farmer-benefit-subhead getiton-subhead">
                  Get Mansthal on
                </p>
                <img src={getitonimg1} className="getitonimg1" />
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Faqs */}
      <section ref={faqRef} id="FAQS">
        <div className="faqbg">
          <div className="container">
            <p className="about-head how-it-work-head">FAQs</p>
            <p className="farmer-benefit-subhead faq-subhead">
              Frequently Asked Questions:
            </p>
            <div className="faq-maindiv">
              {faqdata?.map((item, index) => {
                return (
                  <div className="faq-singlediv" key={index}>
                    <div
                      className="questionrow"
                      onClick={() => {
                        setselectedindex(index);
                      }}
                    >
                      <p className="faq_question">{item?.question}</p>
                      {index == selectedindex ? (
                        <FontAwesomeIcon icon={faMinus} className="faqicon" />
                      ) : (
                        <FontAwesomeIcon icon={faPlus} className="faqicon" />
                      )}
                    </div>
                    {index == selectedindex ? (
                      <p className="faq_answer">{item?.answer}</p>
                    ) : null}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>
      {/* Footer */}
      <section>
        <div className="footermaindiv">
          <div className="container">
            <img src={logo} className="footerlogo" />
            <div className="footercontactrow">
              <Link
                className="footercontactrow1"
                to={"mailto:info@manasthal.com"}
              >
                <FontAwesomeIcon icon={faEnvelope} className="footericon" />
                <p className="footeremail">info@manasthal.com</p>
              </Link>
              <Link className="footercontactrow1" to={"tel:+919959094566"}>
                <FontAwesomeIcon icon={faPhone} className="footericon" />
                <p className="footeremail">+91 9959094566</p>
              </Link>
            </div>
            <div className="footermenurow">
              <div className="footermenu-nav">
                <nav className="navbar navbar-expand-lg  custom-nav ">
                  <ul class="navbar-nav">
                    <li className={"nav-item"}>
                      <p onClick={scrollToHome}>Home</p>
                    </li>
                    <li className={"nav-item"}>
                      <p onClick={scrollToAbout}>About</p>
                    </li>
                    <li className={"nav-item"}>
                      <p onClick={scrollToFeature}>Features</p>
                    </li>
                    <li className={"nav-item"}>
                      <p onClick={scrollToHowItWorks}>How it works</p>
                    </li>
                    <li className={"nav-item"}>
                      <p onClick={scrollToBenefits}>Benefits</p>
                    </li>
                    <li className={"nav-item"}>
                      <p onClick={scrollToTestimonials}>Testimonials</p>
                    </li>
                    <li className={"nav-item"}>
                      <p onClick={scrollToFaqs}>FAQS</p>
                    </li>
                  </ul>
                </nav>
              </div>
              <div className="footerjoinusdiv">
                <p className="joinus-text">Join Us</p>
                <div className="footer-sociodiv">
                  <Link
                    className="header-fb-icon"
                    to={
                      "https://www.facebook.com/profile.php?id=61579143035601"
                    }
                    target="_blank"
                  >
                    <img src={fbicon} className="fbicon" />
                  </Link>
                  <Link
                    className="header-fb-icon"
                    to={"https://x.com/team_mansthal"}
                    target="_blank"
                  >
                    <img src={twiitericon} className="fbicon" />
                  </Link>
                  <Link
                    className="header-fb-icon"
                    to={"https://www.instagram.com/team.mansthal/"}
                    target="_blank"
                  >
                    <img src={instaicon} className="fbicon" />
                  </Link>
                </div>
              </div>
              <div className="footergetitondiv">
                <img src={getitonimg1} className="footergetitonimg" />
              </div>
            </div>
            <hr className="footer-hr" />
            <div className="copyright-row">
              <p className="copyrighttext">
                © Mansthal 2025, All Right Reserved.
              </p>
              <div className="policyrow">
                <Link to={"/terms-conditions"} className="policytext">
                  Terms & Conditions
                </Link>
                <Link to={"/privacy-policy"} className="policytext">
                  Privacy Policy
                </Link>
                <Link to={"/disclaimer"} className="policytext">
                  Disclaimer
                </Link>
                <Link to={"/child-safety"} className="policytext">Child Safety</Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
